
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bcks/announcement",
      function () {
        return require("private-next-pages/bcks/announcement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bcks/announcement"])
      });
    }
  